import { render } from 'preact';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/layout.css';
import './styles/board.css';
import './styles/views.css';
import { App } from './app.jsx';
import { applyTheme, getState, setMySet } from './lib/store.js';
import { SetsApi } from './board/sets-bridge.js';
import { initIdentity } from './lib/identity.js';
import { startHub } from './social/hub.js';
import { play as playSound } from './lib/sound.js';
import { reloadIntoNewVersion } from './lib/version.js';

applyTheme();
// Everyone starts with a set of their own: a gate-safe one, as starter kits use (a set already stored is kept as it is).
if (!getState().mySet) setMySet(SetsApi.randomSafeCode(), { chosen: false });

render(<App />, document.getElementById('app'));

// A very subtle click for buttons across the app (the board has its own sounds).
document.addEventListener('click', e => {
  const b = e.target.closest && e.target.closest('button, .btn, [role="tab"], .switch');
  if (b && !b.disabled && !b.closest('.board-frame, .board')) playSound('click');
}, true);

// Arrow keys in every radio group and tab list (persona-access M3): move to the next option and choose it, as screen
// reader users expect. A group with its own handler calls preventDefault and is left alone.
document.addEventListener('keydown', e => {
  const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
  if (!d || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
  const item = e.target.closest && e.target.closest('[role="radio"], [role="tab"]');
  if (!item) return;
  const group = item.closest(item.getAttribute('role') === 'radio' ? '[role="radiogroup"]' : '[role="tablist"]');
  if (!group) return;
  const items = [...group.querySelectorAll(item.getAttribute('role') === 'radio' ? '[role="radio"]' : '[role="tab"]')]
    .filter(el => !el.disabled && el.getAttribute('aria-disabled') !== 'true' && el.offsetParent !== null);
  const i = items.indexOf(item);
  if (i < 0 || items.length < 2) return;
  e.preventDefault();
  const next = items[(i + d + items.length) % items.length];
  next.focus();
  next.click();
});

// A dynamic import outside the page loader (the engine's fallback, sheets and panels loaded on demand) that fails with
// nothing to catch it, usually because a deploy renamed its chunk: reload once into the new version, by the same rule as
// lazy pages (only when the server serves a newer build).
addEventListener('unhandledrejection', e => {
  const m = String((e.reason && e.reason.message) || e.reason || '');
  if (/dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(m)) reloadIntoNewVersion();
});

initIdentity().then(() => { try { startHub(); } catch (e) { console.warn('Live updates are unavailable', e); } });

if ('serviceWorker' in navigator && !__DEV__ && location.protocol !== 'file:') {
  addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* offline support is a bonus */ });
  });
}
